export enum EWrongLoginAttempts {
  ShowPopup = 'ShowWrongLoginAttemptsPopup'
}
